"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var inertia_react_1 = require("@inertiajs/inertia-react");
var react_i18next_1 = require("react-i18next");
var PartnerSettings_module_css_1 = __importDefault(require("./PartnerSettings.module.css"));
var PartnerSettingsFormItem_1 = __importDefault(require("./PartnerSettingsFormItem"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var PartnerSettingsForm = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var form = (0, inertia_react_1.useForm)({
        id: "",
        name: "",
        addressLine: "",
        postalCode: "",
        city: "",
        country: "",
        contactFullName: "",
        email: "",
        phoneNumber: ""
    });
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var partnerAccount, partnerContact;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiManager_1.default.getPartnerAccount()];
                    case 1:
                        partnerAccount = _a.sent();
                        return [4 /*yield*/, ApiManager_1.default.getPartnerAccountContact()];
                    case 2:
                        partnerContact = _a.sent();
                        form.setData({
                            name: partnerAccount.name || "",
                            id: partnerAccount.id || "",
                            addressLine: partnerAccount.address_line || "",
                            postalCode: partnerAccount.postal_code || "",
                            city: partnerAccount.city || "",
                            country: partnerAccount.country || "",
                            contactFullName: partnerAccount.contactFullName || "",
                            email: partnerContact.email || "",
                            phoneNumber: partnerContact.phone_number || ""
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    return (react_1.default.createElement("form", null,
        react_1.default.createElement("div", { className: PartnerSettings_module_css_1.default.formContainer },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-sm-6" },
                    react_1.default.createElement("div", { className: PartnerSettings_module_css_1.default.title },
                        react_1.default.createElement("span", null, t("Your Partner"))),
                    react_1.default.createElement(PartnerSettingsFormItem_1.default, { text: t("ID") + ":", id: "id", type: "text", value: form.data.id, className: PartnerSettings_module_css_1.default.inputField, readOnly: true, dataCy: "partnerID" }),
                    react_1.default.createElement(PartnerSettingsFormItem_1.default, { text: t("Account name") + ":", id: "name", type: "text", value: form.data.name, className: PartnerSettings_module_css_1.default.inputField, readOnly: true, dataCy: "partnerAccountName" }),
                    react_1.default.createElement(PartnerSettingsFormItem_1.default, { text: t("Address") + ":", id: "addressLine", type: "text", value: form.data.addressLine, className: PartnerSettings_module_css_1.default.inputField, readOnly: true, dataCy: "partnerAddress" }),
                    react_1.default.createElement(PartnerSettingsFormItem_1.default, { text: t("Zip Code") + ":", id: "postalCode", type: "text", value: form.data.postalCode, className: PartnerSettings_module_css_1.default.inputField, readOnly: true, dataCy: "partnerZipCode" }),
                    react_1.default.createElement(PartnerSettingsFormItem_1.default, { text: t("City") + ":", id: "city", type: "text", value: form.data.city, className: PartnerSettings_module_css_1.default.inputField, readOnly: true, dataCy: "partnerCity" }),
                    react_1.default.createElement(PartnerSettingsFormItem_1.default, { text: t("Country") + ":", id: "country", type: "text", value: form.data.country, className: PartnerSettings_module_css_1.default.inputField, dataCy: "partnerCountry", readOnly: true })),
                react_1.default.createElement("div", { className: "col-sm-6 mt-10", style: { marginTop: "70px" } },
                    react_1.default.createElement(PartnerSettingsFormItem_1.default, { text: t("Phone") + ":", id: "phoneNumber", type: "text", value: form.data.phoneNumber, className: PartnerSettings_module_css_1.default.inputField, readOnly: true, dataCy: "partnerPhoneNumber" }),
                    react_1.default.createElement(PartnerSettingsFormItem_1.default, { text: t("E-mail") + ":", id: "email", type: "text", value: form.data.email, className: PartnerSettings_module_css_1.default.inputField, readOnly: true, dataCy: "partnerEmail" }))))));
};
exports.default = PartnerSettingsForm;
